import React from 'react';
import Footer from '../components/Footer.js';
import Navbar from '../components/navbar/Navbar.js';
import CalculatorWindowText from '../components/CalculatorWindowText.js';
import Banner from '../components/Banner.js';
import foeder from '../images/pics/foerderrechner.webp';
import { useSEO } from '../components/CustomHook';

const CalculatorWRF = () => {
    useSEO(
        "Förderrechner Fenster, Dach & Fassade - Kostenlose Berechnung",
        "Berechnen Sie kostenlos Ihre Förderung für Fenster, Dach und Fassade. Erhalten Sie sofort eine detaillierte Übersicht über verfügbare Förderungen.",
        "Förderrechner Fenster, Dach Fassade, Fenster Förderung, Dach Förderung, Fassade Förderung, BEG Förderung",
        "/images/pics/foerderrechner.webp"
    );

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={foeder}
                title="Förderrechner Fenster, Dach & Fassade"
                subtitle="Berechnen Sie Ihre Förderung"
                description="Erhalten Sie sofort eine detaillierte Übersicht über verfügbare Förderungen für Fenster, Dach und Fassade. Sparen Sie mit unseren Förderprogrammen."
            />
            <CalculatorWindowText />
            <Footer />
        </>
    )
}

export default CalculatorWRF;

